import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import {toggleAbout} from '../settings-panel/store/settingsSlice';
import DialogContent from '@mui/material/DialogContent';

import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function AboutModal(props) {

    const isAboutOpened = useSelector((state) => state.settings.isAboutOpened);
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(toggleAbout());
    }

    return (
        <Dialog
            fullScreen
            open={isAboutOpened}
            onClose={handleClose}
            TransitionComponent={Transition}
        >
            <AppBar sx={{position: 'relative'}}>
                <Toolbar>
                    <Typography sx={{ml: 2, flex: 1}} variant="h6" component="div">
                        About & Tips
                    </Typography>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                    >
                        <CloseIcon/>
                    </IconButton>
                </Toolbar>
            </AppBar>
            <DialogContent>

                <p>
                    Before telling you about me or this project I would like you to watch
                    the short video below. I insist on this because I know how valuable these
                    advices are, since I committed all these errors while learning morse code myself.
                </p>

                <div className='w-full pt-4'>
                    <iframe
                        className={"w-full aspect-video"}
                        src="https://www.youtube.com/embed/7QcvtbuLpbA"></iframe>
                </div>

                <p className='pt-4'>
                    Hello! The person in the video is not me. My name is André Luiz and I'm a
                    Brazilian who is currently living in Montreal, Canada. Besides that,
                    I'm also a full-stack web developer and Amateur Radio Operator.
                    I got my first Amateur Radio license back in 2002 and my Advanced license
                    the next year (we call it a Class A license).
                </p>

                <p className='pt-4'>
                    I decided to code this small App to help me learn Morse code in a level that allows me to handle
                    long conversations,
                    not only the regular DX (long-distance contacts) exchanges which are pretty short and easy.
                </p>

                <p className='pt-4'>
                    This App was designed for mobile first and I hope you can also use it to learn Morse code. Soon more
                    modes will be available!
                </p>

                <div className='w-full pt-4'>

                    <strong>This was my CW studying plan. If you don't have a studying plan, consider using this one: </strong><br/><br/>

                    <iframe
                        className={"w-full aspect-video"}
                        src="https://www.youtube.com/embed/gcAzNQCK9NA"></iframe>
                </div>

                <p className='pt-4'>
                    <strong>Here are some other great softwares to help you in your journey:</strong>
                    <List>
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => window.open('https://www.g4fon.net/')}>
                                <ListItemText primary="G4FON's Softwares" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => window.open('http://www.dxatlas.com/morserunner/')}>
                                <ListItemText primary="Morse Runner" />
                            </ListItemButton>
                        </ListItem>                        
                    </List>

                </p>


                <p className='pt-4'>
                    <strong>Useful links:</strong>
                    <List>
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => window.open('https://cwops.org/wp-content/uploads/2018/07/CW-Abbreviations.pdf')}>
                                <ListItemText primary="CW Abbreviations List" />
                            </ListItemButton>

                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => window.open('https://tamiamiarc.org/more-cw-resources/')}>
                                <ListItemText primary="CW resources: common words, states, phareses" />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </p>

                <div
                    className="max-w-sm bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700"
                    style={{ margin: '0 auto' }}
                >
                    <div className="flex flex-col items-center py-10">

                        <h5 className="mb-5 text-xl font-medium text-gray-900 dark:text-white">Creator of the App</h5>

                        <img className="mb-3 w-24 h-24 rounded-full shadow-lg" src="https://cdn-bio.qrz.com/x/ve2zdx/avatar.png?p=c0897f24a0b8b86898f765cef18e5d78" alt="André Luiz"></img>
                        <h5 className="mb-1 text-xl font-medium text-gray-900 dark:text-white">André Luiz</h5>
                        <span className="text-sm text-gray-500 dark:text-gray-400">VE2ZDX</span>
                        <div className="flex mt-4 space-x-3 lg:mt-6">
                            <a
                                href="https://www.qrz.com/db/VE2ZDX"
                                target={'_blank'}
                                className="inline-flex items-center py-2 px-4 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                QRZ Page
                            </a>
                        </div>
                    </div>
                </div>


            </DialogContent>
        </Dialog>
    );


}

export default AboutModal;